/**
 * Resolve a public/ asset path (`/images/foo.png`) against the app's base URL.
 *
 * Public assets referenced as plain JS strings are NOT rewritten by Vite. Under
 * a relative base ('./' — Electron and other embedded builds loading from
 * file://) an absolute path like `/images/OttoHead.png` resolves to the
 * filesystem root and fails; in web builds (base '/') this is a no-op.
 *
 * Note: values read at module scope before app bootstrap (e.g. top-level
 * constants built from brand.images) must call this explicitly — the one-time
 * normalization in main.ts only covers later reads.
 */
export function assetUrl(path: string | undefined | null): string {
  if (!path) return '';
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  const base = import.meta.env.BASE_URL || '/';
  return `${base}${path.replace(/^\//, '')}`;
}
